/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import { CircularProgress, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { FullAssignment, Nullable } from "../../utils/Interfaces";
import { updateTechnicianAssignments } from "./technicianDashboardFunctions";
import TechnicianAssignmentCardList from "./TechnicianAssignmentCardList";
import StyledBreadcrumbs from "../../components/general/StyledBreadcrumbs";
import { useSearchParams } from "react-router-dom";
import { useWindowDimensions } from "../../utils/Hooks";
import { useAppDispatch } from "../../app/hooks";

const TechnicianDashboard = () => {
    const dispatch = useAppDispatch();

    const { width } = useWindowDimensions();
    let mobile: boolean = width <= 600;

    const [assignments, setAssignments] = useState<FullAssignment[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const [searchParams] = useSearchParams();
    const status: Nullable<string> = searchParams.get("status");

    // Initiate Long Polling of Entries.
    // The list will be refreshed every 60 seconds.
    // Only the first pull will render the circular progress wheel.
    useEffect(() => {
        updateTechnicianAssignments(dispatch, setAssignments, setLoading);

        let timer: NodeJS.Timer = setInterval(() => {
            updateTechnicianAssignments(dispatch, setAssignments);
        }, 60000);

        return () => clearInterval(timer);
    }, [dispatch]);

    return (
        <Box>
            <StyledBreadcrumbs
                paths={[
                    { text: "Techwise Portal", route: "/" },
                    { text: mobile ? "Services" : "Service Dashboard", route: `/tech-dash?status=${status}` },
                ]}
            />

            <Container sx={{ width: "100%", padding: "0px" }}>
                {loading && (
                    <Stack direction="row" justifyContent="center" sx={{ mt: 20 }}>
                        <CircularProgress size="4rem" />
                    </Stack>
                )}

                {!loading && <TechnicianAssignmentCardList assignments={assignments} />}
            </Container>
        </Box>
    );
};

export default TechnicianDashboard;
